import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router does NOT reset the scroll position on navigation (it's a SPA - the browser
 * has no reason to scroll since there's no real page load). Without this, clicking a link
 * while scrolled down on one page lands you at the same scroll depth on the new page instead
 * of at its top. Mounted inside <BrowserRouter> so useLocation() works correctly.
 */
export default function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
